import { render } from "./wokerDetail18.vue?vue&type=template&id=1e2a109c&scoped=true"
import script from "./wokerDetail18.vue?vue&type=script&lang=js"
export * from "./wokerDetail18.vue?vue&type=script&lang=js"

import "./wokerDetail18.vue?vue&type=style&index=0&id=1e2a109c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2a109c"]])

export default __exports__